import React from 'react';

export default React.createContext(null);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/services/Context.js